const PDF_MIME_TYPE = "application/pdf";
const PDF_SIGNATURE = [0x25, 0x50, 0x44, 0x46, 0x2d]; // %PDF-
const PDF_HEADER_SCAN_BYTES = 1024;

const readFileHeader = (file: File): Promise<Uint8Array> =>
  new Promise((resolve) => {
    const reader = new FileReader();
    reader.onload = () =>
      resolve(new Uint8Array(reader.result as ArrayBufferLike));
    reader.onerror = () => resolve(new Uint8Array());
    reader.readAsArrayBuffer(file.slice(0, PDF_HEADER_SCAN_BYTES));
  });

const containsPdfSignature = (header: Uint8Array): boolean => {
  for (
    let offset = 0;
    offset <= header.length - PDF_SIGNATURE.length;
    offset++
  ) {
    if (PDF_SIGNATURE.every((byte, index) => header[offset + index] === byte)) {
      return true;
    }
  }
  return false;
};

/** Verify the browser metadata and the file's PDF content signature. */
export const isPdfFile = async (file: File): Promise<boolean> => {
  if (!file.name.toLowerCase().endsWith(".pdf")) return false;
  if (file.type.toLowerCase() !== PDF_MIME_TYPE) return false;

  return containsPdfSignature(await readFileHeader(file));
};
